export default __webpack_public_path__ + "static/media/envelope-w.58c32e51.svg";